<template>
  <div>
    <b-modal ref="blackoutModal" :title="title" :ok-only="true">{{
      description
    }}</b-modal>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "BlackoutPeriods",
  data() {
    return {
      title: "",
      description: "",
      blackout_start: "",
      blackout_end: ""
    };
  },
  props: ["startdate", "blackout_periods", "passtype", "passTypeDefinition"],
  watch: {
    startdate() {
      this.update();
    },
    passtype() {
      this.update();
    }
  },
  methods: {
    update() {
      //If blackout_periods is not set, do nothing
      if (!this.blackout_periods) {
        return;
      }
      if (
        this.passTypeDefinition &&
        this.passTypeDefinition.duration == "annual"
      ) {
        //Annual passes are excluded
        return;
      }
      this.blackout_periods.forEach(period => {
        let start = moment(this.startdate, "MM/DD/YYYY");
        let blackout_start = moment(period.start_date, "YYYY-MM-DD");
        let blackout_end = moment(period.end_date, "YYYY-MM-DD");
        if (start >= blackout_start && start <= blackout_end) {
          this.title = period.name;
          this.description = period.description;
          this.blackout_start = blackout_start.calendar();
          this.blackout_end = blackout_end.calendar();

          //Show modal
          this.$refs.blackoutModal.show();
        }
      });
    }
  }
};
</script>
